import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://rwjhxphrhdzjkxleogkk.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJ3amh4cGhyaGR6amt4bGVvZ2trIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzkyNzcxMjcsImV4cCI6MjA5NDg1MzEyN30.AHPBrKaawjVWraqjMVcgivPjpl216-DPBrjSeA-dfCc'

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)
